module.exports = __webpack_public_path__ + "img/logo.0ea4a229.png";